import React from 'react';

export default function StatCard({ title, value, subtitle, onClick, ariaLabel, hint = 'Ver detalhes' }) {
  const clickable = typeof onClick === 'function';

  const handleKeyDown = (event) => {
    if (!clickable) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`admin-card ${clickable ? 'clickable' : ''}`}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-label={clickable ? (ariaLabel || title) : undefined}
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
    >
      <h3>{title}</h3>
      <div className="value admin-card-value">{value}</div>
      {subtitle ? <p className="admin-card-subtitle">{subtitle}</p> : null}
      {clickable ? <p className="admin-card-hint">{hint}</p> : null}
    </div>
  );
}
